import axios from 'axios';

const getBaseUrl = () => {
  const base = process.env.REACT_APP_API_URL || '';
  return base.replace(/\/$/, '');
};

const getStorageUrl = (path) => {
  if (!path) return '';
  const base = getBaseUrl();
  const apiBase = base.endsWith('/api') ? base.replace(/\/api$/, '') : base;
  return `${apiBase}/api/storage/${path}`;
};

export const fetchBannersBySection = async (section) => {
  try {
    const base = getBaseUrl();
    const apiBase = base.endsWith('/api') ? base : `${base}/api`;
    const response = await axios.get(`${apiBase}/banners/${encodeURIComponent(section)}`, {
      timeout: 10000,
    });
    const data = response.data?.data ?? response.data;
    if (Array.isArray(data)) {
      const mapped = data.map((b) => ({
        ...b,
        imageDesktopUrl: getStorageUrl(b.image_desktop),
        imageMobileUrl: b.image_mobile ? getStorageUrl(b.image_mobile) : null,
      }));
      mapped.sort((a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0));
      return mapped;
    }
    return [];
  } catch (err) {
    console.warn('[Banner] Failed to fetch banners:', err.message);
    return [];
  }
};

export { getStorageUrl };
